import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { MOBILE_QRY } from '~/config';

export const ControlWrapper = styled.div<{
  isActive: boolean;
  haveDynamicWidth: boolean;
}>`
  min-width: 32px;
  min-height: 32px;
  max-width: 32px;
  max-height: 32px;
  border-radius: 50%;

  ${MOBILE_QRY} {
    min-height: 40px;
    min-width: ${props => (props.haveDynamicWidth ? 'auto' : '40px')};
  }

  &:hover {
    background: var(--neut7);
  }

  ${props =>
    props.isActive &&
    !props.haveDynamicWidth &&
    css`
      background-color: var(--hover1);
    `}
`;
